class GalleriesController {
    init() {

    }

    index() {
        // Table sorting and pagination now handled by Stimulus table controller
    }

    edit() {
        galleriesOnEditOrNew();
    }

    new() {
        galleriesOnEditOrNew();
    }

    show() {
        let contentSwiper = new window.Swiper(".swiper.gallery-top", {
            direction: 'horizontal',
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            centeredSlides: true,
            initialSlide: 0,
            keyboard: {
                enabled: true,
                onlyInViewport: false
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            zoom: true,
            pagination: {
                el: '.swiper-pagination'
            }
        });

        function updateModalToggle() {
            const galleryTop = document.querySelector('.gallery-top');
            if (galleryTop) {
                const activeImg = galleryTop.querySelector(".swiper-slide-active > img");
                if (activeImg) {
                    activeImg.setAttribute('data-bs-toggle', 'modal');
                    activeImg.setAttribute('data-bs-target', '#galleryModal');
                }
            }
        }

        function updateModalImg() {
            const galleryTop = document.querySelector('.gallery-top');
            if (galleryTop) {
                const activeImg = galleryTop.querySelector(".swiper-slide-active > img");
                const modalImg = document.getElementById('galleryModalImg');
                if (activeImg && modalImg) {
                    const imgSource = activeImg.getAttribute("src");
                    modalImg.setAttribute("src", imgSource);
                }
            }
        }

        window.addEventListener("load", function() {
            updateModalToggle();
            updateModalImg();
        });

        contentSwiper.on("slideChangeTransitionStart", function() {
            updateModalToggle();
            updateModalImg();
        });
    }
}

window.BC = window.BC || {};
window.BC.galleries = new GalleriesController();

function galleriesOnEditOrNew() {
    // File upload now handled by modern Stimulus file-upload controller
    // Gallery image sorting migrated to Stimulus sortable controller
    // See app/javascript/controllers/sortable_controller.js
}